import React from 'react';
import { IIconProps } from './utils';

export const AIText = ({
  fill = 'currentColor',
  height = 10,
  width = 17,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 17 10"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M13.4792 2.82473L13.7642 1.70972H17L16.9977 2.08139L13.4792 2.82473Z"
      fill={fill}
    />
    <path
      d="M5.29815 0H7.6472L8.88557 9.39092H6.89397L6.65141 7.36466H3.00016L1.88946 9.39092H0L5.29815 0ZM3.82999 5.84497H6.47267L6.02584 1.84441L3.82999 5.84497Z"
      fill={fill}
    />
    <path
      d="M11.7369 1.68855L12.0816 0.0129887H14.0988L13.7541 1.68855H11.7369ZM10.1922 9.39092L11.571 2.81857H13.4604L12.0816 9.39092H10.1922Z"
      fill={fill}
    />
  </svg>
);
